import React from "react";
import {
  Button,
  Form,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Checkbox
} from "react-bootstrap";
import Select from "react-select";
import Datetime from "react-datetime";
import map from "lodash/map";
import { ABNORMALITIES, I18N } from "../../../../constants";

class RFUSearch extends React.Component {
 render() {
    const {
      search,
      emcs,
      plants,
      docks,
      validations,
      isValidToDate,
      handleChange,
      handleEmcCodeChange,
      handlePlantCodeChange,
      handleDockCodeChange,
      handleDateChange,
	  handleSelectChange,
      onSubmit,handleCheckboxChange
    } = this.props;

    let dockList = {};
    if (docks) {
      dockList = docks.map(dock => ({
        value: dock.code,
        label: dock.code
      }));
    }

    let abnormalityTypeList = {};

    abnormalityTypeList = map(ABNORMALITIES, a => (
      {
        value: a,
        label: I18N.ABNORMALITIES[a]
      }
    ));

    
    return (

      

      <Form inline>
        <FormGroup controlId="fromDate">
          <ControlLabel>From: </ControlLabel>
          <Datetime
            className={validations.fromDate && "datetime-error"}
            value={search.fromDate}
            onChange={handleDateChange("fromDate")}
            dateFormat="DD-MM-YYYY"
            timeFormat={false}
            inputProps={{ maxLength: 255, placeholder: "..." }}
            closeOnSelect
          />
          {validations.fromDate && (
            <p style={{ color: "#CF142B", margin: 5 }}>
              {validations.fromDate}
            </p>
          )}
        </FormGroup>
        <FormGroup controlId="toDate">
          <ControlLabel>To: </ControlLabel>
          <Datetime
            className={validations.toDate && "datetime-error"}
            value={search.toDate}
            onChange={handleDateChange("toDate")}
            dateFormat="DD-MM-YYYY"
            timeFormat={false}
            inputProps={{ maxLength: 255, placeholder: "..." }}
            isValidDate={isValidToDate}
            closeOnSelect
          />
          {validations.toDate && (
            <p style={{ color: "#CF142B", margin: 5 }}>{validations.toDate}</p>
          )}
        </FormGroup>
        <FormGroup controlId="emc">
          <ControlLabel>EMC: </ControlLabel>
          <br />
          <FormControl
            componentClass="select"
            name="emcCode"
            value={search.emcCode}
            onChange={handleEmcCodeChange}
          >
            <option value="">...</option>
            {map(emcs, emc => (
              <option key={emc.code} value={emc.code}>
                {emc.code}
              </option>
            ))}
          </FormControl>
        </FormGroup>
        <FormGroup controlId="emcPlantCode">
          <ControlLabel>Plant: </ControlLabel>
          <br />
          <FormControl
            componentClass="select"
            name="emcPlantCode"
            value={search.emcPlantCode}
            onChange={handlePlantCodeChange}
          >
            <option value="">...</option>
            {map(plants, plant => (
              <option key={plant.code} value={plant.code}>
                {plant.code}
              </option>
            ))}
          </FormControl>
        </FormGroup>

               <FormGroup controlId="showManifestNumber">
                        <p ><b> Show manifest number  </b>

                            <Checkbox style={{ marginTop: -20, marginLeft: 10 }} inline="true"
                                name="showManifestNumber"
                                checked={this.props.showManifestNumber}
                                onChange={handleCheckboxChange}

                            />
                        </p>
                    </FormGroup>
        
        <Row>
          <FormGroup controlId="emcDockCode">
            <Col sm={6} componentClass={ControlLabel}>
              Docks: <br />
            </Col>
            <Col sm={12}>
              {dockList && dockList.length > 0 && (
                <Select
                  value={search.emcDockCode}
                  options={dockList}
                  placeholder="..."
                  isMulti
                 // simpleValue
                // joinValues
                  delimiter=","
                  onChange={handleDockCodeChange("emcDockCode")}
                />
              )}
            </Col>
          </FormGroup>
        </Row>
        <FormGroup controlId="supplierCode">
          <ControlLabel>Supplier code: </ControlLabel>
          <br />
          <FormControl
            id="supplierCode"
            name="supplierCode"
            type="text"
            value={search.supplierCode}
            placeholder="..."
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup controlId="supplierName">
          <ControlLabel>Supplier name: </ControlLabel>
          <br />
          <FormControl
            id="supplierName"
            name="supplierName"
            type="text"
            value={search.supplierName}
            placeholder="..."
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup controlId="abnormalityType">
          <ControlLabel name='abntpy' id='abntpy'>Abn. type: </ControlLabel>
          <br />
         {/* <FormControl
            componentClass="select"
            name="abnormalityType"
            value={search.abnormalityType}
            onChange={handleChange}
          >
            <option value="">...</option>
            {map(ABNORMALITIES, a => (
              <option key={a} value={a}>
                {I18N.ABNORMALITIES[a]}
              </option>
            ))}
          </FormControl>*/}
          <Col>
            <Select 
              value={search.abnormalityType}
              options={abnormalityTypeList}
              placeholder="..."
              isMulti
              //simpleValue
              //joinValues
              delimiter=","
              onChange={handleSelectChange("abnormalityType")}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="abnormalityStatus">
          <ControlLabel>Status: </ControlLabel>
          <br />
          <FormControl
            componentClass="select"
            name="abnormalityStatus"
            value={search.abnormalityStatus}
            onChange={handleChange}
          >
            <option value="">...</option>
            <option value="RFU_ALL">{I18N.RFU_STATUS.RFU_ALL}</option>
            <option value="RFU_ABNORMALITIES">
              {I18N.RFU_STATUS.RFU_ABNORMALITIES}
            </option>
            <option value="RFU_OPEN_ABNORMALITIES">
              {I18N.RFU_STATUS.RFU_OPEN_ABNORMALITIES}
            </option>
          </FormControl>
        </FormGroup>
        <FormGroup controlId="submit">
          <br />
          <Button
            bsStyle="primary"
            disabled={Object.keys(validations).length > 0}
            onClick={onSubmit}
          >
            Load data
          </Button>
        </FormGroup>
                
      </Form>
      
    );
  }
}

export default RFUSearch;
